/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import THDCustomer from '@thd-olt-global/thd-customer';
import _isEmpty from 'lodash/isEmpty';
import _toLower from 'lodash/toLower';
import find from 'lodash/find';
import get from 'lodash/get';
import { saveConfiguration } from '@gcc/configurator';
import replace from 'lodash/replace';
import featureGates from '../utils/featureGates';
import {
  CREATE_DESIGN,
  CREATE_DESIGN_FAILED,
  UPDATE_ITEM_PRODUCT,
  UPDATE_ITEM_PRODUCT_FAILED,
  // GET_DESIGN_BY_ITEM,
  // GET_DESIGN_BY_ITEM_FAILED,
  SAVE_CONFIG_START,
  SAVE_CONFIG_SUCCESS,
  SAVE_CONFIG_FAILED,
  // beginLoadingDesign,
  // endLoadingDesign
} from './actionCreators';
import { trackSaveAndContinue, trackUpdateDesign } from '../utils/analytics/trackEvents';
import { scheduleMeasureUrlSelector } from '../selectors/scheduleMeasureUrl';
import {
  APP_ACTION_CREATE_DESIGN_FAILED,
  APP_ACTION_DESIGN_EMAIL_FAILED,
  logNewRelicError,
} from '../utils/newRelicActions';

const flooringBaseUrl = typeof window !== 'undefined' ? window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'] : '';
const flooringCartBaseUrl = `${flooringBaseUrl}/estimate`;

const getEnvBaseRedirect = () => {
  const { hostname, port, pathname } = window.location;
  return `${hostname}:${port}${pathname}`;
};

const removePreSelectedQueryParams = (envQueryStr) => {
  if (envQueryStr.get('carpettype')) {
    envQueryStr.delete('carpettype');
  }
  if (envQueryStr.get('multiChoice')) {
    envQueryStr.delete('multiChoice');
  }
  if (envQueryStr.get('steps')) {
    envQueryStr.delete('steps');
  }
  if (envQueryStr.get('rooms')) {
    envQueryStr.delete('rooms');
  }
  if (envQueryStr.get('pad')) {
    envQueryStr.delete('pad');
  }
  if (envQueryStr.get('carpet')) {
    envQueryStr.delete('carpet');
  }
  if (envQueryStr.get('item')) {
    envQueryStr.delete('item');
  }
  if (envQueryStr.get('productId')) {
    envQueryStr.delete('productId');
  }
  return envQueryStr.toString();
};

const redirectToCart = (designId) => {
  const envBaseRedirect = getEnvBaseRedirect();
  const envQueryStr = new URLSearchParams(window.location.search);
  let queryString = removePreSelectedQueryParams(envQueryStr);
  queryString = queryString ? `?${replace(queryString, '&save=1', '')}` : '';
  const redirectUrl =
    `${flooringCartBaseUrl}/${designId}?saved=1&envBaseRedirect=${envBaseRedirect}&envQueryString=${encodeURIComponent(queryString)}`;
  window.location.href = redirectUrl;
};

const redirectToLogin = (omsId, itemId) => {
  const thdLoginUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['thd-login-url'];
  const envQueryStr = new URLSearchParams(window.location.search);
  const queryString = removePreSelectedQueryParams(envQueryStr);
  const returnUrl = `${window.location.pathname}?${queryString}&productId=${omsId}&item=${itemId}`;
  window.location.href = `${thdLoginUrl}?redirect=${returnUrl}&save=1&ref=null`;
};

const sendSaveDesignEmail = (designId, productId, itemId, svocID, samUrl) => {
  const envBaseRedirect = getEnvBaseRedirect();
  const envQueryStr = new URLSearchParams(window.location.search);
  let queryString = removePreSelectedQueryParams(envQueryStr);
  queryString = queryString ? `?${replace(queryString, '&save=1', '')}` : '';
  const path = 'designs/sendSaveDesignEmail';
  const url = `${flooringBaseUrl}/designs/sendSaveDesignEmail/?envBaseRedirect=${envBaseRedirect}&envQueryString=${encodeURIComponent(queryString)}`;
  const { email: recipientEmailId } = THDCustomer;
  return axios.post(url, {
    designId,
    recipientEmailId,
    productId: `${productId}`,
    itemId: `${itemId}`,
    svocID,
    samUrl
  }).catch((err) => {
    logNewRelicError(
      APP_ACTION_DESIGN_EMAIL_FAILED,
      path,
      get(err, 'status', 500),
      url,
      { designId, recipientEmailId, productId }
    );
    throw err;
  });
};

export const addDesign = (
  name,
  productLine,
  zip,
  containerType,
  defaultContainerName,
  itemLabelPrefix,
  itemType,
  storeNumber,
  doSaveConfiguration = false,
) => (dispatch) => {
  const designId = uuidv4();
  const containerId = uuidv4();
  const itemId = uuidv4();
  const groupId = uuidv4();
  const path = 'api/designs/save';
  const url = `${flooringBaseUrl}/api/designs/save`;
  const envBaseRedirect = getEnvBaseRedirect();
  const pirateCartUrl = `${flooringCartBaseUrl}/${designId}/?envBaseRedirect=${envBaseRedirect}`;
  const designAttributes = [
    { designId, name: 'Origin', value: 'Online' },
    { designId, name: 'PirateCartUrl', value: pirateCartUrl }
  ];

  const newDesign = {
    designId,
    name,
    productLine,
    zipCode: zip,
    storeNumber,
    attributes: designAttributes
  };
  const newContainer = {
    containerId,
    name: defaultContainerName || `${containerType} 1`,
    containerType,
  };
  const newItem = {
    designId,
    itemId,
    label: `${itemLabelPrefix} 1`,
    itemSource: 'Autobahn',
    containerId,
    attributes: [],
    groupId,
  };
  const payload = {
    design: newDesign,
    containers: [newContainer],
    items: [newItem],
  };

  axios.post(url, payload)
    .then((response) => {
      dispatch({ type: CREATE_DESIGN, payload: response.data });
      if (doSaveConfiguration) {
        dispatch(saveConfiguration({ clearOnSave: false }));
      }
    }).catch((err) => {
      logNewRelicError(
        APP_ACTION_CREATE_DESIGN_FAILED,
        path,
        get(err, 'status', 500),
        url,
        { containerId, designId, itemId });
      dispatch({ type: CREATE_DESIGN_FAILED, payload: err.response && err.response.data });
    });
};

export const saveConfig = () => (dispatch, getState) => {
  const state = getState();
  const { design: { currentDesign }, store: { storeNumber } } = state;

  dispatch({ type: SAVE_CONFIG_START });
  window.scrollTo(0, 0);

  if (_isEmpty(currentDesign)) {
    dispatch(addDesign('Design 1', 13, '', 'Room', 'Room 1', 'flooring', 'flooring', Number(storeNumber), true));
  } else {
    dispatch(saveConfiguration({ clearOnSave: false }));
  }
};

export const addItemProduct = (designId, itemId, configurationGuid) => (dispatch, getState) => {
  dispatch({ type: SAVE_CONFIG_START });

  const url = `${flooringBaseUrl}/designs/${designId}/items/${itemId}`;
  const state = getState();
  const {
    design: { designAssociated },
    config: { productId, partnerProductId }
  } = state;
  const inEditFlow = designAssociated;
  const isFromSave = window.location.search.includes('save=1');
  const { samUrl } = scheduleMeasureUrlSelector(state);
  return axios.post(url, { configurationGuid })
    .then((response) => response)
    .then((updatedDesign) => {
      dispatch({ type: UPDATE_ITEM_PRODUCT, payload: updatedDesign.data });
      if (updatedDesign.data.items?.[0]?.itemProduct?.attributes) {
        const room = find(
          updatedDesign.data.items[0].itemProduct.attributes,
          // TODO: The 'Enter Rooms' option below needs to be removed after configurator copy update
          (attribute) => attribute.name === 'Enter Rooms' || attribute.name === 'Measure Your Rooms'
        );
        if (room && room.value) {
          // track analytics
          if (inEditFlow) {
            trackUpdateDesign(JSON.parse(room.value).sku);
          } else {
            trackSaveAndContinue(JSON.parse(room.value).sku);
          }
        }
      }
    })
    .then(() => {
      if (!designAssociated || isFromSave) {
        if (THDCustomer.isLoggedIn) {
          const svocId = window.THDCustomer.default.svocID;
          return sendSaveDesignEmail(designId, productId, itemId, svocId, samUrl);
        }
      }
      return Promise.resolve(false);
    })
    .then(() => {
      const { enableSaveAndContinue } = featureGates;
      if (!designAssociated) {
        if (THDCustomer.isLoggedIn) {
          return Promise.resolve(enableSaveAndContinue);
        }
        redirectToLogin(partnerProductId, itemId);
        return Promise.resolve(false);
      }

      return Promise.resolve(enableSaveAndContinue);
    })
    .then((shouldRedirectToCart) => {
      if (shouldRedirectToCart) {
        redirectToCart(designId);
      }
    })
    .then(() => {
      dispatch({ type: SAVE_CONFIG_SUCCESS });
    })
    .catch((err) => {
      dispatch({ type: SAVE_CONFIG_FAILED });
      dispatch({ type: UPDATE_ITEM_PRODUCT_FAILED, payload: err.response && err.response.data });
      throw err;
    });
};
